import { AfterViewChecked, ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm, custom } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MovDoc } from '../../class/mov-doc.class';
import { CaptionComponent } from '../../components/caption/caption.component';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaDynamicContentComponent } from '../../components/nica-dynamic-content/nica-dynamic-content.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaFiltroComponent } from '../../components/shared/nica-filtro/nica-filtro.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService, detailOptions } from '../../services/forms-template.service';
import { ModelliStampaService } from '../../services/modelli-stampa.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { DettagliMovimentiCaricoScaricoComponent } from '../dettagli-movimenti-carico-scarico/dettagli-movimenti-carico-scarico.component';


const colonneSoggetto =
  [

    {
      allowFixing: true,
      type: 'campo',
      dataField: "ragioneSociale",
      caption: "Ragione Sociale",
      dataType: "",
      orderGriglia: 1,
      maxLength: '45',
      maxSize: 45,
      colVisible: true,
      colWidth: '870',
      showInColumnChooser: false,
      allowHiding: false,
    }

  ]



const colonneSede =
  [
    {

      type: 'campoMultiData',
      colWidth: '94px',
      dataField: 'tipoAttivita',
      colVisible: true,
      hideOnEdit: true,
      caption: 'Tipo attività',
      dataType: 'object',

    },
    {
      type: 'campo',
      dataField: 'descrizione',
      dataType: '',
      colWidth: '385px',
      caption: 'Descrizione',
      allowEditing: true,
      colVisible: true,
    },
    {
      type: 'campo',
      dataField: 'indirizzo',
      dataType: '',
      colWidth: '205px',
      caption: 'Indirizzo',
      allowEditing: true,
    },
    {
      type: 'campo',
      dataField: 'comune',
      dataType: '',
      colWidth: '100px',
      caption: 'Comune',
      allowEditing: true,
    },
    {
      type: 'campo',
      dataField: 'siglaProvincia',
      dataType: '',
      colWidth: '83px',
      caption: 'Provincia',
      allowEditing: true,
    },
  ]

const cusaliPanelMovimenti = {
  dynamic: {
    dataSource: "CausaleRifiuti",
    service: 'CausaliRifiuti',
    autocomplete: false,
    valueExpr: '',
    displayExpr: 'descrizione',
    searchExpr: '',
    caption: "",
    filterStatic: '',
    componentType: 'dynamicGrid',
    settingGrid: {
      masterKey: 'id',
      keyUnique: '',
      mode: null,
      selectionMode: 'single',
      remoteOperations: true,
      hoverStateEnabled: true,
      rowAlternationEnabled: true,
      repaintChangesOnly: true,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      height: 530,

      showColBlank: false,
      colonne: [
        {
          dataField: 'idTipoOperazione',
          dataType: '',
          caption: 'Tipo',
          allowEditing: false,
          groupIndex: 0,
          colSpan: 3,
          lista: {
            dataSource: 'TipoOperazioneCausaleRifiuti',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,


          }
        },
        {
          dataField: 'idOperazione',
          dataType: '',
          caption: 'Operaz.',
          allowEditing: false,
          width: '30'
        },
        {
          dataField: 'descrizione',
          dataType: '',
          caption: 'Descrizione',
          allowEditing: false,
          width: '770'
        },
      ],

    },
    settingDetail: {

      dynamic: {

        costantValue: [
          { key: 'idOperazione', value: 'idOperazione' },
          { key: 'trasporto', value: 'trasporto' }
        ],
        related: ['idOperazione'],
        dataSource: "PosizioneCausale",
        service: 'PosizioneCausale',
        valueExpr: '',
        displayExpr: 'id',
        queryString: '?idCausale=$id',
        filterStatic: '',
        componentType: 'dynamicGrid',

        settingGrid: {
          masterKey: 'id',
          keyUnique: '',
          mode: null,
          selectionMode: 'single',
          remoteOperations: true,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          allowUpdating: false,
          allowDeleting: false,
          allowAdding: false,
          height: 300,
          width: 798,
          showColBlank: false,
          colonne: [
            {
              dataField: 'idPosizioneRifiuto',
              dataType: '',
              caption: 'Codice',
              allowEditing: true,
              colVisible: false
            },
            {
              dataField: 'posizioneRifiuto_Descrizione',
              dataType: '',
              caption: 'Posizione',
              allowEditing: true,
              /* lista: {
                dataSource: 'PosizioneRifiuti',
                valueExpr: 'id',
                displayExpr: 'descrizione',
                static: false
              } */
            },
          ],


        },
      }


    }

  }
}

const giacenzePanelMovimenti = {
  dynamic: {
    dataSource: "GiacenzaRifiuti",
    service: '',

    valueExpr: '',
    displayExpr: 'eer',
    searchExpr: '',
    caption: "",
    filterStatic: '',
    queryStringFilter: '',
    componentType: 'dynamicGrid',
    related: ['idStatoFisico', 'riferimentoEER'],
    settingGrid: {
      masterKey: 'id',
      keyUnique: '',
      mode: null,
      selectionMode: 'single',
      remoteOperations: true,
      hoverStateEnabled: true,
      rowAlternationEnabled: true,
      showFilterSearch: false,
      repaintChangesOnly: true,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      height: 430,

      showColBlank: false,
      colonne: [
        {
          dataField: 'descrizioneTipoCarico',
          dataType: '',
          caption: 'Tipo Carico',
          allowEditing: false,

          colWidth: '200px'
        },
        {
          dataField: 'eer',
          dataType: '',
          caption: 'EER',
          allowEditing: false,
          colWidth: '66px'
        },
        {
          dataField: 'idStatoFisico',
          dataType: '',
          caption: 'SF',
          allowEditing: false,
          colWidth: '42px'
        },
        {
          dataField: 'riferimentoEER',
          dataType: '',
          caption: 'Riferimento',
          allowEditing: false,
          colWidth: '75px'
        },

        {
          dataField: 'giacenzaIniziale',
          dataType: '',
          caption: 'Giac.Iniz.',
          allowEditing: false,
          colWidth: '90px'
        },
        {
          dataField: 'carico',
          dataType: '',
          caption: 'Carico',
          allowEditing: false,
          colWidth: '90px'
        },
        {
          dataField: 'scaricoInterno',
          dataType: '',
          caption: 'Scarico',
          allowEditing: false,
          colWidth: '90px'
        },
        {
          dataField: 'scaricoATerzi',
          dataType: '',
          caption: 'Scar.Terzi',
          allowEditing: false,
          colWidth: '90px'
        },
        {
          dataField: 'giacenzaFinale',
          dataType: '',
          caption: 'Giac. Fin.',
          allowEditing: false,
          colWidth: '90px'
        },


        {
          type: 'colsSum',
          dataField: "giacenzaIniziale",
          colCaption: 'GI',
        },

        {
          type: 'colsSum',
          dataField: "carico",
          colCaption: 'S I',
        },
        {
          type: 'colsSum',
          dataField: "scaricoInterno",
          colCaption: 'S I',
        },

        {
          type: 'colsSum',
          dataField: "scaricoATerzi",
          colCaption: 'S I',
        },

        {
          type: 'colsSum',
          dataField: "giacenzaFinale",
          colCaption: 'S I',
        },

      ],

    }

  }
}



@Component({
  selector: 'app-movimenti-carico-scarico',
  templateUrl: './movimenti-carico-scarico.component.html',
  styleUrls: ['./movimenti-carico-scarico.component.css']
})
export class MovimentiCaricoScaricoComponent extends MovDoc implements OnInit, AfterViewChecked {

  // @ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;

  @ViewChild('movimentoFiltriScarichi', { static: false }) movimentoFiltriScarichi: NicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicGridComponent: NicaDynamicContentComponent;

  @ViewChild('gridCausali', { static: false }) gridCausali: DxDataGridComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;
  @ViewChild('captionComponent', { static: false }) captionComponent: CaptionComponent;
  @ViewChild('toolbar', { static: false }) toolbar: ToolbarComponent;

  @ViewChild('nicaFiltro', { static: false }) nicaFiltro: NicaFiltroComponent;
  @ViewChild('dettagliMovimento', { static: false }) dettagliMovimento: DettagliMovimentiCaricoScaricoComponent;


  moment = require('moment')
  causali: any;
  selectCausaleRifiutiPanel: boolean = false
  posizioniByCausale: any[] = [];
  buttonCustom: any[] = []
  buttonCustom2: any[] = []
  posCausaleFilter: string;
  PulsanteFiltro: any;
  showFilterScarichiForm: boolean = false
  buttonCustomFormFiltriScarico: any[];
  dataFiltriScarichiJson: any = {};
  newMov: boolean = false;
  calcolaVolumePeso: any;
  totalPesoScaricato: any;
  customDialog;
  dynamicGrid: any;

  idMovimentoSelezionato?: number;
  public modelliStampaService: ModelliStampaService;
  /** Nome della key e del form template usati per i filtri (assicurarsi di avere un template con il medesimo nome)*/
  // cerPericoloso: boolean = false;
  elencoFormulariVisibile: boolean = false;
  codiceCausale: string
  filterBlocchiViviFir: any;
  showBlocchiViviFirAzienda: boolean = false;
  showForm: boolean = false;
  operazioneCausale: any;
  showToolbarTop: boolean = false
  schedeDiLavorazione: any[] = [];
  causaleDataSelected: object | undefined
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    public apiService: Apiservice,
    private cdref: ChangeDetectorRef
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,
      loader,
      formservice,
    );
  }


  ngAfterViewChecked(): void {
    if (this.cd)
      this.cd.detectChanges();
  }


  ngAfterViewInit() {



    if (this.SubjectCall == 'movimentiRifiuto' && this.template == 'form') {


    }



  }

  ngOnInit() {
    this.activatedroute.queryParams.subscribe((params) => {
      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName
      this.showToolBar = false
      this.setGlobalVariableFromParams(params)
      if (this.template == 'form') {
        this.codiceCausale = this.filterID['causale_Id_Operazione']
        var state = this.filterID['isEdit'] ? '(Modifica)' : '(Nuovo)'
      }
      this.titleDynamic = `Registro carico e scarico rifiuti${state !== undefined ? ' ' + state : ''}`;
      this.buttonCustom2 = [
        {

          location: "after",
          widget: "dxButton",
          locateInMenu: "never",
          stylingMode: 'text',
          text: 'Scheda tecnica rifiuto',
          hint: "Incolla dati rifiuto dalla scheda tecnica (F12)",
          accesskey: 'F',
          icon: "glyphicon icon-elenco-cer-trasp",
          event: "SchedarifiutiComponent",
          name: "addSchedaTecnica",
          visible: false

        },

        {
          name: 'GiacenzeRifiuti',
          widget: "dxButton",
          icon: 'glyphicon icon-giacenze-magazzino',
          hint: 'Giacenze rifiuti',
          location: 'after',
          event: 'StatisticarifiutiComponent',
          visible: false


        },

      ]


      //console.log('filterID-->',this.filterID)
      if (this.filterID['idPosizioneCausale'] && this.template == 'form' && !this.filterID['isEdit']) {
        this.rowData = this.filterID;
      }

      if (this.filterID['idMovimento'] && this.template == 'form' && this.SubjectCall == 'scaricoRifiuto') {

        this.rowData = this.filterID;

      }


      if (params.service) {

        this.filterTemplateKey = 'movimentiRifiutoFiltri';

        let filtriOBJ: Object = JSON.parse(localStorage.getItem('Filtri'));

        //this.filterTemplateKey = this.filterTemplateKey.replace('formulari', 'movimenti');

        if (filtriOBJ && filtriOBJ[this.filterTemplateKey]) {


          if (filtriOBJ[this.filterTemplateKey].queryString.length > 0) {

            //this.filterGrid =

            filtriOBJ[this.filterTemplateKey].queryString = !filtriOBJ[this.filterTemplateKey].queryString.includes('=') ? '' : filtriOBJ[this.filterTemplateKey].queryString;


            if (this.filterGrid.toLowerCase().endsWith('asc') || this.filterGrid.toLowerCase().endsWith('desc'))
              this.filterGrid += '&' + filtriOBJ[this.filterTemplateKey].queryString.replace(/[?]/g, '');  //this.filterGrid.split('?')[0];
            else
              this.filterGrid += filtriOBJ[this.filterTemplateKey].queryString;  //this.filterGrid.split('?')[0];


            setTimeout(
              () => {

                for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {

                  if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {


                    (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#edcd5f';

                    break;
                  }

                }
                if (this.nicaAnagrafica)
                  this.nicaAnagrafica.griglia.instance.refresh();
              }, 500
            );

          }
        }


      }
    });


    if (this.SubjectCall == 'movimentiRifiuto' && this.template == 'grid') {

      //this.captionComponent.breadcrumbCaption='Causale e Posizione'

      //this.filterGrid = "?$count=true&$orderby=DataRegistrazione desc,Contatore desc"

      this.PulsanteFiltro = [
        {
          location: 'before',
          options: {
            icon: 'glyphicon mdi mdi-filter-outline',
            title: '',
            text: 'Ricerca movimenti registrati',
            index: 1,
            id: "uno",
            event: 'filterMov'
          }
        },

      ]


    }


    this.customDialog = custom({
      title: "Attenzione!",
      messageHtml: "Movimento completato",
      buttons: [{
        text: "Salvare e chiudi",
        onClick: (e) => {
          return 0
        }
      },
      {
        text: "Salva e inserisci nuovo",
        onClick: (e) => {
          return 1
        }
      },
      {
        text: "Annulla",
        onClick: (e) => {

          return 2;
        }
      },
      ]
    })
  }


  async renderForm(event) {
    const form = event.component;
    //controllo se l'id produttore e l'id trasportatore hanno nsAzienda true
    if (event.formData && event.formData['produttore_Id_Soggetto']) {
      if (event.formData.produttore_Id_Soggetto !== null) {
        const res: any = await this.apiService.GetApi(`Soggetto/${event.formData.produttore_Id_Soggetto}`)
        if (!res.nsAzienda) {
          // form.itemOption('dati-generali-movimento.autorizzazioneProduttore_Descrizione_Full', 'disabled', true);
          form.itemOption('dati-generali-movimento.autorizzazioneProduttoreArea_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.cantiere_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.magazzinoProduttore_Descrizione', 'disabled', true);
        }
      }
    }

    if (event.formData && event.formData['destinatario_Id_Soggetto']) {
      if (event.formData.destinatario_Id_Soggetto !== null) {
        const res: any = await this.apiService.GetApi(`Soggetto/${event.formData.destinatario_Id_Soggetto}`)
        if (!res.nsAzienda) {
          // form.itemOption('dati-generali-movimento.autorizzazioneDestinatario_Descrizione_Full', 'disabled', true);
          form.itemOption('dati-generali-movimento.magazzinoDestinatario_Descrizione', 'disabled', true);
          form.itemOption('dati-generali-movimento.autorizzazioneDestinatarioArea_Full', 'disabled', true);
        }
      }
    }

    if (this.filterID['isEdit']) {
      if (event.formData['caratteristiche_di_pericolo'] !== null && event.formData['caratteristiche_di_pericolo'] !== '') {
        // event.component.dataSet['isCerPericoloso'] = true
        event.formData.isCerPericoloso = true
        // this.cerPericoloso = true

      }
      console.log('ssssssssssssssss', event.formData)
    }

    if (!this.filterID['isEdit']) form.formRefreshInputData('dataFormulario', new Date())
    form.itemOption('dati-generali-movimento.numeroFormulario', 'disabled', false);

    //fine controllo
  }
  /***Evento Griglia***/
  movimentoGridSelect(event) {


    /*  if (event.id)
       this.dettagliMovimento.changeMovimento(event.id);
 
 
     return; */

  }

  movimentoTestButton($event) {
    let data = {
      id: 10
    }
    this.refreshPage(data, '', this.SubjectCall, 'form');

  }
  async movimentoGridEvent(event) {
    if (event.name === 'onRowRemoving') {
      console.log(event)
      const data = event.data || null
      if (data && data.protocollo) {
        event.cancel = true
        const uuid = Math.random().toString().replace("0.", "");
        const dataToSend = {
          service: 'rettifica',
          api: '',
          type: "simple",
          remoteOperation: false,
          dataJson: {
            Motivazione: '',
            idRelaz: event.key
          }
        }
        this.userComponentService.setNewPopUp(uuid, 'NewNicaFormComponent', null, '600', null, dataToSend, false, true, 'Generazione Rettifica Annullamento', 'center', null)
        this.userComponentService.outputComponent.subscribe(async (res) => {
          if (res.name === 'return' && res.guid == uuid) {
            return this.userComponentService.destroyCurrentOpenPopUpByGuid(uuid);
          }
          if (res.name === "submitFormStatic" && res.guid == uuid) {
            try {
              const annot = await this.apiService.PutApi(`MovimentoRifiuti/${res.data.idRelaz}/ModificaAnnotazioni`, { text: res.data.Motivazione })
              if (annot) {
                await this.apiService.DeleteApi(`MovimentoRifiuti/${res.data.idRelaz}`)
                return this.userComponentService.destroyCurrentOpenPopUpByGuid(uuid);
              }
            } catch { } finally {
              const filter = this.nicaAnagrafica.filter
              this.nicaAnagrafica.resetFilter()
              this.nicaAnagrafica.filter = filter
              this.nicaAnagrafica.refresh()
            }
            //cociocicicicicicicicic
          }
        })
      }
    }


    if (event.name == 'onCellPrepared') {
      if (event.dataField === "isRentri") {
        let mostraTag = [];
        if (event.data) {
          if (event.data.idRentri !== null) {
            mostraTag.push(
              {
                class: 'badge rentri-prova ms-2',
              }
            )
          }
          event.cellElement.innerHTML = mostraTag.map(item => `<span class="${item.class}"></span>`).join('');
        }
      }
      //onCellPrepared
      if (event.rowType == 'data') {
        const data = event.data;
        if (event.column.dataField == 'mostraScaricoR') {
        }
        if (event.column.dataField == 'mostraScaricoR') {
          if (data.causale_Id_Operazione == "A1" || data.causale_Id_Operazione == "A2" || data.causale_Id_Operazione == "A3" || data.causale_Id_Operazione == "A4" || data.causale_Id_Operazione == "A5" || data.causale_Id_Operazione == "A6" || data.causale_Id_Operazione == "A7" || data.causale_Id_Operazione == "C1" || data.causale_Id_Operazione == "C2") {
            (event.cellElement as HTMLElement).title = "";
            (event.cellElement as HTMLElement).setAttribute('disabled', "true");
            (event.cellElement as HTMLElement).innerHTML = '';
          } else {
            /* if(data.quantitaKg<100){ 
           
              (event.cellElement as HTMLElement).querySelector('.dx-icon').classList.add("redClass");
  
              } */
          }
        }
      }


    }


    if (event.name == "onInitilized" && event.componentName == 'movimentiRifiuto') {

      this.movimentoDetailInit(event)

    }

    if (event.name == "onInitNewRow") {
      event.cancel = true
      this.renderCausaleContent();

    }

    if (event.name == "onEditorPrepared") {
      this.loader.show()
      event.cancel = true
      let datatoSend = event.data
      datatoSend.isEdit = true;
      this.filterID = datatoSend;
      this.filterID['isEdit'] = true;
      this.loader.hide()
      this.refreshPage(datatoSend, '', this.SubjectCall, 'form');
      if (event.name === "onEditorPrepared" && event.componentName === "movimentiRifiuto") {
        if (event.data) {
          if (event.data.protocollo !== null) {
            alert('Il movimento selezionato è già stato inviato al Rentri su uno o più registri, pertanto ogni variazione genererà un movimento di rettifica da inviare nella prima data utile.', 'Attenzione');
          }
        }
      }
    }



    if (event == "resettaFiltro") {
      this.resettaFiltroApplicato(this.filterTemplateKey)
      if (!this.filterTemplateKey || this.filterTemplateKey.length == 0)
        return;


      if (this.nicaFiltro) {

        //console.warn('sto resettando filtro');
        //this.nicaFiltro.resetFormFiltro();
      }


      //localStorage.removeItem(this.filterTemplateKey);



      setTimeout(
        () => {

          for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {

            if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {

              //console.warn('icona trovata');

              (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#023957';

              break;
            }

          }

        }, 500
      );


      this.pannelloFiltriAvanzatiVisibile = false;



      this.nicaAnagrafica.griglia.instance.refresh();

    }

    if (event == "pannelloFiltriAvanzatiVisibile") {
      //console.warn(event);

      //this.pannelloFiltriAvanzatiVisibile = true;
      /*#nicaFiltro id="filtroFormPopup" [captionHidden]="true" [nColForm]="2"  [filtroKeyLocalStorage]="filterTemplateKey" [nomeTemplate]="filterTemplateKey" (onAllEventFiltroForm)="onAllEventFiltro($event)" (filterQueryStringEmitter)="onFilterQueryStringEmitted($event)"*/
      let instanceData = {
        filtroKeyLocalStorage: this.filterTemplateKey,
        nomeTemplate: this.filterTemplateKey,
        captionHidden: true,
        nColForm: '2'

      }
      //let guid = this.openComponentInPopUP('NicaFiltroComponent', [], instanceData, '1550', 'Filtri Avanzati', false, true);


    }


    return

    //this.gridEvent(event)
  }
  /*
    onFilterQueryStringEmitted(queryString: string) {
  
      console.log('ciao');
      alert("ciao", "errore");
      //console.log("ECCO QUERY STRING ", queryString);
  
      if (!this.nicaAnagrafica.griglia.instance)
        return;
  
  
  
      this.nicaAnagrafica.griglia.instance.clearFilter();
  
      this.nicaAnagrafica.griglia.selectedRowKeys = [];
  
  
      //queryString = !queryString.includes('=') ? '' : queryString;
  
  
  
  
  
      //console.log(document.getElementById('bottoneFiltroToolbar'));
  
      //document.getElementById('bottoneFiltroToolbar').classList.add('text-danger');='red';
      //document.getElementById('bottoneFiltroToolbar').classList.add('text-danger');
  
      for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {
  
        if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {
  
  
          if (queryString)
            (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#edcd5f';
          else
            (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#023957';
  
  
          break;
        }
  
      }
  
  
      if (!queryString)
        this.filterGrid = '';
      else
        this.filterGrid = queryString;
  
  
  
      this.nicaAnagrafica.griglia.instance.refresh();
  
      this.pannelloFiltriAvanzatiVisibile = false;
  
    }
  
  */

  async onChiusuraAnnullaFiltro(evt) {
    if (this.nicaFiltro)
      await this.nicaFiltro.annullaFiltro();
    this.pannelloFiltriAvanzatiVisibile = false;
  }

  /**Causale Rifiuti wrap***/

  renderCausaleContent() {

    this.loader.show();
    this.causali = [];

    let idTable = Math.random().toString().replace("0.", "")

    const instanceData = {
      idTable: idTable,
      service: '',
      colonne: [
        {
          dataField: 'idTipoOperazione',
          dataType: '',
          caption: 'Tipo',
          colSpan: 3,
          allowEditing: false,
          groupIndex: 0,
          colWidth: '90',
          lista: {
            dataSource: 'TipoOperazioneCausaleRifiuti',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,


          }
        },
        {
          dataField: 'idOperazione',
          dataType: '',
          caption: 'Op.',
          allowEditing: false,
          colWidth: '35'
        },
        {
          dataField: 'descrizione',
          dataType: '',
          caption: 'Descrizione',
          allowEditing: false,
          colWidth: '365'
        },
      ],
      api: 'CausaleRifiuti',
      tableHeight: 500,
      tableWidth: 600,
      remoteOperation: true,
      isEditable: false,
      selectionRowMode: 'detail',
      showFilter: false,
      isSearchable: false,
      isEditableNewRow: false,
      isOdata: true,
      queryString: "?$filter=(isExistsPosizione eq true)",
      filterStatic: '',
      showToolbarTop: true,
      toolbarButtonsTop: [
        {
          id: 'formularioCopy',
          name: 'formularioCopy',
          text: 'Ricopia XFIR',
          event: "formularioCopy",
          hint: 'Ricopia documento accompagnatorio',
          icon: 'glyphicon mdi mdi-content-paste',
          disabled: false,
          visible: true,
          widget: 'button'

        }
      ],
      detailOptions: <detailOptions>{

        isRemote: true,
        service: 'PosizioneCausale',
        api: 'PosizioneCausale',
        isEditable: false,
        queryString: '?idCausale=$id',
        colonne: [
          {
            dataField: 'idPosizioneRifiuto',
            dataType: '',
            caption: 'Codice',
            allowEditing: true,
            colVisible: true,
            colWidth: 30
          },
          {
            dataField: 'posizioneRifiuto_Descrizione',
            dataType: '',
            caption: 'Posizione',
            allowEditing: true,
            colWidth: 440

          },
        ],

      }

    }

    //this.copiaDaXFir()

    const width = '600'
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, width, null, instanceData, true, true, 'Seleziona la causale');

    this.loader.hide()
    let data = []

    this.userComponentService.outputComponent.subscribe(currentOutput => {
      console.log('toolbarButtonClick', currentOutput);
      if (currentOutput.name == "toolbarButtonClick" && currentOutput.guid == guid) {


        if (currentOutput.infoEventButtons.event == 'formularioCopy') {
          this.formularioCopy()

          //this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
          //this.userComponentService.destroyOutputComponent();
        }
      }

      if (currentOutput.name == "onRowExpanded" && currentOutput.guid == guid) {
        data['isSpurghi'] = currentOutput.data.spurghi


        if (typeof currentOutput.expandedData != 'undefined') {
          if (currentOutput.expandedData.length == 1) {
            data['idPosizioneCausale'] = currentOutput.expandedData[0]['id']
            data['causale_Trasporto'] = currentOutput.data.trasporto
            this.causaleDataSelected = currentOutput.data;
            this.getTempMov(currentOutput.expandedData[0]['id'], data);
            this.userComponentService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
            this.userComponentService.destroyOutputComponent();
          }
        }

      }
      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {
        data['isSpurghi'] = currentOutput.data.spurghi
        if (currentOutput.data.id && currentOutput.infoRows.isRowDetail) {


          data['idPosizioneCausale'] = currentOutput.data.id;
          data['causale_Trasporto'] = currentOutput.fatherData.trasporto;
          this.causaleDataSelected = currentOutput.fatherData;
          this.getTempMov(currentOutput.data.id, data);
          this.userComponentService.destroyCurrentOpenPopUp('NicaDataGridComponent');
          this.userComponentService.destroyOutputComponent();

        }
      }


    })


    return


  }


  formularioCopy() {
    //sviluppi in corso
    const instanceData = {
      campoTabRif: '',
      keyUnique: '',
      idTable: 'id',
      service: 'FormulariDaMov',
      api: `DocumentoRifiuti`,
      // elimina: false,
      // modifica: false,
      // aggiungi: false,
      isExportDocxAvailable: false,
      isExportPDFAvailable: false,
      isExportExcelAvailable: false,
      tableHeight: 600,
      tableWidth: 1700,
      searchType: 'contains',
      remoteOperation: true,
      isEditable: false,
      selectionRowMode: 'single',
      showFilter: true,
      isSearchable: true,
      isEditableNewRow: false,
      isOdata: true,
      queryString: "",
      filterStatic: '',
      showToolbarTop: true,
      // dxocolumnchooser: false,
      toolbarButtonsTop: [

        {
          id: 'removeFiltraFormulari',
          name: 'removeFiltraFormulari',
          text: '',
          event: "removeFiltraFormulari",
          hint: 'Filtra XFIR per causale, posizione, trasportatore ecc..',
          icon: 'glyphicon icon-remove-filter',
          disabled: false,
          visible: true,
          widget: 'button',

        },
        {
          id: 'filtraFormulari',
          name: 'filtraFormulari',
          text: '',
          event: "filtraFormulari",
          hint: 'Filtra XFIR per causale, posizione, trasportatore ecc..',
          icon: 'glyphicon icon-filter',
          disabled: false,
          visible: true,
          widget: 'button'

        },
      ],



    }



    let guid = Math.random().toString().replace('0.', '')
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', [], '', '', instanceData, true, true, 'Elenco Formulari da ricopiare')

    // this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, '1520', null, instanceData, false, true, 'Elenco Formulari da ricopiare', 'top');

    this.userComponentService.outputComponent.subscribe(currentOutput => {
      console.log('currentOutput', currentOutput.name)
      if (currentOutput.name === "dataSourceChange" && currentOutput.guid == guid) {
        currentOutput.masterComponent.dataSource = (this.template && this.template == 'form')
          ? currentOutput.masterComponent.dataSource.filter((i) => i.causale_Id_Operazione === this.codiceCausale)
          : currentOutput.data
      }
      if (currentOutput.name === 'onCellPrepared' && (currentOutput.dataField === "copiaComeNuovo" || currentOutput.dataField === "isRentri")) {
        currentOutput.column.visible = false;
      }

      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {
        let dataRow = currentOutput.data;

        this.copiaDaXFir(dataRow);

      }

      if (currentOutput.name == "toolbarButtonClick" && currentOutput.guid == guid) {
        const masterComponent = currentOutput.masterComponent
        if (currentOutput.infoEventButtons.event == "removeFiltraFormulari") {
          let filtriOBJ = JSON.parse(localStorage.getItem('Filtri'));
          const obj = `${this.apiset}FiltriPop`;
          delete filtriOBJ[obj];
          localStorage.setItem('Filtri', JSON.stringify(filtriOBJ));

          masterComponent.queryString = '';
          masterComponent.refresh();
          const filtraFormulariBtn = document.getElementById('filtraFormulari') as HTMLElement;
          const iconFilter = filtraFormulariBtn.getElementsByClassName('icon-filter')[0] as HTMLElement
          iconFilter.style.removeProperty('color');
        }



        if (currentOutput.infoEventButtons.event == 'filtraFormulari') {


          const filtroKeyLocalStorage = `${this.apiset}FiltriPop`
          let instanceData = {
            filtroKeyLocalStorage: filtroKeyLocalStorage,
            nomeTemplate: 'movimentiRifiutoFiltri2',
            captionHidden: true,
            nColForm: '2',
            title: 'Filtri Avanzati'

          }

          let guidP = this.openComponentInPopUP('NicaFiltroComponent', [], instanceData, '1450', 'Filtri Avanzati', false, false, null, '-');

          this.userComponentService.outputComponent.subscribe(currentOutput => {
            console.log('Ricevuto evento:', currentOutput);
            if (currentOutput.name == 'return' && currentOutput.guid == guidP) {
              this.userComponentService.destroyCurrentOpenPopUpByGuid(guidP)

              return
            }

            if (currentOutput.name == 'queryOk' && currentOutput.guid == guidP) {

              masterComponent.queryString = currentOutput.queryString;
              masterComponent.refresh();
              const filtraFormulariBtn = document.getElementById('filtraFormulari') as HTMLElement;
              const iconFilter = filtraFormulariBtn.getElementsByClassName('icon-filter')[0] as HTMLElement
              iconFilter.style.color = '#edcd5f';
              this.userComponentService.destroyCurrentOpenPopUpByGuid(guidP);

            }
          })
        }
      }
    })

  }


  async copiaDaXFir(data) {

    this.loader.show();

    let queryString = '/RicopiaDocumentoAccompagnatorio?idFormulario=' + data.id;
    const api = this.apiset;
    let newData = {}
    let Movresult = await this.anagraficaService.getValue(api, '', queryString)


    for (let x in Movresult) {


      newData = { ...newData, [x]: Movresult[x] }
    }

    this.filterID = newData;

    this.filterID['isEdit'] = false;



    // this.userComponentService.destroyCurrentOpenPopUps()
    this.userComponentService.destroyCurrentOpenPopUp('NicaDataGridComponent')
    setTimeout(() => {

      this.refreshPage([], '', this.SubjectCall, 'form')
      //this.userComponentService.destroyCurrentOpenPopUp('NicaDataGridComponent')
      this.loader.hide()
    }, 500);


  }
  getTempMovFromExisting(idPosizioneCausale, data) {


    this.loader.show();
    let queryString = '/GetTemp?IdPosizioneCausale=' + idPosizioneCausale;
    const api = this.apiset;
    let newData = data
    this.anagraficaService.getValue(api, '', queryString).then(Movresult => {
      let resTempMov = Movresult
      for (let x in resTempMov) {
        newData = { [x]: resTempMov[x], ...newData }
      }
      this.filterID = newData;
      this.filterID['isEdit'] = false;
      sessionStorage.removeItem(this.apiset)
      this.refreshPage([], '', this.SubjectCall, 'form')
    })
  }
  getTempMov(idPosizioneCausale, data) {


    this.loader.show();
    let queryString = '/GetTemp?IdPosizioneCausale=' + idPosizioneCausale;
    const api = this.apiset;
    let newData = data
    this.anagraficaService.getValue(api, '', queryString).then(Movresult => {

      let resTempMov = Movresult
      for (let x in resTempMov) {


        newData = { ...newData, [x]: resTempMov[x] }
      }

      this.filterID = newData;

      this.filterID['isEdit'] = false;

      sessionStorage.removeItem(this.apiset)

      this.refreshPage([], '', this.SubjectCall, 'form')






    })
  }
  formDataGridEvent(event) {
    if (event && event.name === 'onRowSelectionChange' && event.accessoringData.dataField === "id_Eer") {
      if (this.formAnagrafica) this.formAnagrafica.dataSet['isCerPericoloso'] = event.data['pericoloso']
    }
  }

  async checkValidationsForm(event): Promise<boolean> {

    //rimuovo la virgola per quantitaKg, per quantitaRespinta e per quantitaOrigineToPrint
    if (typeof event.formData.quantitaKg === 'string') event.formData.quantitaKg = Number(event.formData.quantitaKg.replace(',', '.'))
    if (typeof event.formData.quantitaRespinta === 'string') event.formData.quantitaRespinta = Number(event.formData.quantitaRespinta.replace(',', '.'))
    if (typeof event.formData.quantitaOrigineToPrint === 'string') event.formData.quantitaOrigineToPrint = Number(event.formData.quantitaOrigineToPrint.replace(',', '.'))

    /*********************** */
    event.cancel = true;
    event.cancella = true;
    const fail = (msg: string) => {
      alert(msg, 'Attenzione');
      // event.cancella = true;
      // event.cancel = true;
      return;
    };
    const formData = event.formData;
    const idOperazione = formData.causale_Id_Operazione;
    let idCaricoAutomatico = formData.idCaricoAutomatico
    let attivaRintracciabilita = formData.attivaRintracciabilita
    let caricoDaMiscelazione = formData.caricoDaMiscelazione
    //let IsCaricoAutomaticoRifiutiDaLavorazione  = formData.isCaricoAutomaticoRifiutiDaLavorazione 
    let validation = event.isValid;
    let formDataMovimento = formData

    if (formData && !formData.isCerPericoloso && formData.listaHP.length > 0) {
      fail('Il rifiuto non è pericoloso ma sono state indicate le caratteristiche di pericolo')
      return false
    }

    if (formData.isCerPericoloso && !(formData.listaHP.length > 0)) {
      fail('Caratteristiche di pericolo obbligatorie')
      return false
    }

    const idCausale = formData.idCausale || null
    const idOperazioneRD = formData.idOperazioneRD || null
    if (idCausale && idOperazioneRD) {
      const causaleData = this.causaleDataSelected || await this.apiService.GetApi(`CausaleRifiuti/${idCausale}`).then((res: any) => {
        this.causaleDataSelected = res
        return res;
      })
      const causale_Id_Operazione = formData.causale_Id_Operazione || causaleData['idOperazione']
      console.log('causaleData', causaleData)
      if (causaleData) {
        if (causaleData['listaOperazioniRD'].length === 0) {
          const operazioni = ['R13', 'D15']
          if (causale_Id_Operazione === 'A2' && !operazioni.includes(idOperazioneRD)) {
            fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            return false;
          }
          if (causale_Id_Operazione === 'A3' && operazioni.includes(idOperazioneRD)) {
            fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
            return false;
          }
          if (causale_Id_Operazione === 'A4' && !operazioni.includes(idOperazioneRD)) {
            fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            return false;
          }
          if (causale_Id_Operazione === 'A5' && operazioni.includes(idOperazioneRD)) {
            fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
            return false;
          }
          if (causale_Id_Operazione === 'A6' && !operazioni.includes(idOperazioneRD)) {
            fail('La causale può essere associata solo ad operazioni di tipo R13 o D15')
            return false;
          }
          if (causale_Id_Operazione === 'A7' && operazioni.includes(idOperazioneRD)) {
            fail('La causale NON può essere associata ad operazioni di tipo R13 o D15')
            return false;
          }
        } else {
          if (!causaleData['listaOperazioniRD'].includes(idOperazioneRD)) {
            fail(`La causale può essere associata solo ad operazioni di tipo ${causaleData['listaOperazioniRD'].join(', ')}`)
            return false;
          }
        }
      }

    }
    const dataDoc = formData['dataFormulario'];
    const dataRegistrazione = formData['dataRegistrazione'];
    const dataInizioTrasporto = formData['dataInizioTrasporto'];
    const dataFineTrasporto = formData['dataFineTrasporto'];
    const oraInizioTrasporto = formData['oraInizioTrasporto'];
    const oraFineTrasporto = formData['oraFineTrasporto'];
    const mHourStart = oraInizioTrasporto ? this.moment(oraInizioTrasporto, 'HH:mm') : null;
    const mHourEnd = oraFineTrasporto ? this.moment(oraFineTrasporto, 'HH:mm') : null;
    const mDoc = dataDoc ? this.moment(dataDoc).startOf('day') : null;
    const mReg = dataRegistrazione ? this.moment(dataRegistrazione).startOf('day') : null;
    const mStart = dataInizioTrasporto ? this.moment(dataInizioTrasporto).startOf('day') : null;
    const mEnd = dataFineTrasporto ? this.moment(dataFineTrasporto).startOf('day') : null;
    const toDay = this.moment().startOf('day');
    const oraAttuale = this.moment()

    // if (mDoc && !mStart) {
    //   fail('È stata inserita la data del FIR, inserire anche la data di inizio')
    //   return false;
    // }

    // if (mStart && !mDoc) {
    //   fail('È stata inserita la data di inizio, inserire anche la data del FIR')
    //   return false;
    // }

    if (mReg && mReg.isAfter(toDay)) {
      fail('La data di registrazione non può essere futura alla data odierna')
      return false;
    }

    if (mDoc && mDoc.isAfter(mReg)) {
      fail('La data del FIR non può essere futura alla data di registrazione')
      return false;
    }

    if (mDoc && mStart && mStart.isBefore(mDoc)) {
      fail('La data di inizio trasporto non può essere precedente alla data del FIR')
      return false;
    }
    // if (mDoc && mReg && mReg.isBefore(mDoc)) {
    //   fail('La data presunta non può essere precedente alla data del FIR')
    //   return false;
    // }
    // if (mReg && mStart && mStart.isAfter(mReg)) {
    //   fail('La data di inizio trasporto non può essere superiore alla data presunta');
    //   return false;
    // }
    if (mEnd && mStart && mEnd.isBefore(mStart)) {
      fail('La data di fine trasporto non può essere precedente alla data di inizio trasporto');
      return false;
    }

    if (mStart && mDoc && mStart.isBefore(mDoc)) {
      fail('La data di inizio trasporto non può essere antecedente alla data del FIR')
      return false;
    }

    // if (mHourStart && mHourStart.isBefore(oraAttuale, 'minute')) {
    //   fail(`L'ora di inizio non può essere antecedente all'orario attuale: ${oraAttuale.format('HH:mm')}`);
    //   return false;
    // }

    if (mHourEnd && mHourEnd.isBefore(mHourStart)) {
      fail(`L'ora di fine non può essere antecedente all'orario di inizio`);
      return false;
    }



    if (formData.causale_Trasporto == 'P') {
      if (formData.dataInizioTrasporto == null) {
        fail('Data inizio trasporto obbligatoria');
        return false;
      }
      if (idOperazione === 'B2') {
        if (formData.dataFineTrasporto == null && (formData.tipoAccettazione && formData.tipoAccettazione !== "")) {
          fail('Data fine trasporto obbligatoria');
          return false;
        }
      }
    }
    try {

      let validationByApi: any = await this.anagraficaService.actionPut('MovimentoRifiuti/convalida', formDataMovimento, false);

      if (validationByApi.length > 0) {
        let arrayBlocca = validationByApi.filter(blc => blc.blocca == true);
        let arrayAvvisa = validationByApi.filter(blcA => blcA.avvisa == true);

        let html = '';
        if (arrayBlocca.length > 0) {
          // event.resultSubject.next(false);
          // event.resultSubject.complete();

          arrayBlocca.forEach(rr => {
            html += `<p>${rr.descrizione}</p>`;
          });

          alert(html, 'Errore!');


          return false;
        }

        if (arrayAvvisa.length > 0) {

          // event.resultSubject.next(false);
          // event.resultSubject.complete();
          html = '<div style="max-width:700px;max-height: 600px;overflow-y:auto;">';
          arrayAvvisa.forEach(rr => {
            html += `<p>${rr.descrizione}</p>`;
          });
          html += '<p>Desideri procedere con il salvataggio del movimento comunque?</p>'
          html += '</div>'
          let confirmMov = await confirm(html, 'Attenzione')

          if (!confirmMov) return false
          // if (confirmMov) {
          //   this.formMovimento.formRefreshInputData('force', true);
          //   event.resultSubject.next(true);
          //   event.resultSubject.complete();
          //   this.formMovimento.onFormSubmit();
          // } else {
          //   event.resultSubject.next(false);
          //   event.resultSubject.complete();
          //   this.formMovimento.formRefreshInputData('force', false);
          // }


        }
      }

      if (formData.causale_Trasporto == 'P' && formData.dataFineTrasporto == null) {
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete()

        let message = '<p>La data di fine trasporto non è stata indicata, vuoi indicarla successivamente? </p>'
        let confirmMov = await confirm(message, 'Attenzione')

        if (!confirmMov) return false
      }

      if (idOperazione == 'B2' && idCaricoAutomatico && validation && !this.filterID['isEdit']) {
        // event.cancella = false;

      }

      if (idOperazione == 'A1' && attivaRintracciabilita && validation) {
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete();
        this.formPanelRintracciabilitaRifiuti(event, formData, attivaRintracciabilita, false);
        return

      }

      if (idOperazione == 'A2' && attivaRintracciabilita && validation) {
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete();
        this.formPanelRintracciabilitaRifiuti(event, formData, attivaRintracciabilita, false);
        return
      }

      if (idOperazione == 'A1' && caricoDaMiscelazione && validation) {
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete();
        this.formPanelMiscelazione(event, formData, caricoDaMiscelazione);
        return
      }
      if (idOperazione == 'A2' && caricoDaMiscelazione && validation) {
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete();
        this.formPanelMiscelazione(event, formData, caricoDaMiscelazione);
        return
      }

      if ((idOperazione == 'B1' || idOperazione == 'B2' || idOperazione == 'B3') && validation) {
        let listaMagazziniDestinatario = [];
        // event.cancella = true;
        // event.resultSubject.next(false);
        // event.resultSubject.complete();
        await this.anagraficaService.getElenco('MagazzinoRifiuti', '', '?idSede=' + formData['idProduttore']).then(res => {
          if (res['items']) {
            res['items'].forEach(reee => {
              listaMagazziniDestinatario.push(reee['id']);
            })
            formData.listaMagazziniDestinatario = listaMagazziniDestinatario;
            return this.formCarichiDaAbbinare(event, formData);
          }

        })
        return
      }


      // event.resultSubject.next(false);
      // event.cancella = true;
      await this.generaRettifica(formData)
      // event.masterComponent.onFormSubmit()
      return true;
    } catch (error) {
      console.error('Errore durante la convalida', error);
      // event.resultSubject.next(false);
      // event.resultSubject.complete();
      return false;
    }
  }

  async formButtonsEvent(event) {







    /*********************** */

    if (event.name == 'beforSave') {
      await this.checkValidationsForm(event)
    }

    if (event.name == 'submittedInsertOk') {
      let data = event.formData
      if (!data.idPosizioneCausale && !data.id) {
        return
      }

      delete data.id;



      data['idPosizioneCausale'] = this.filterID['idPosizioneCausale']
      data['causale_Trasporto'] = this.filterID['causale_Trasporto']


      this.filterID = []
      this.getTempMov(data.idPosizioneCausale, data)
      Object.keys(event.formData).forEach(key => {
        event.formData[key] = null
      });
    }

    if (event.name == 'submittedEditOk') {


      let data = event.formData;

      if (!data.idPosizioneCausale && !data.id) {
        return
      }
      /**Gestisco i queryurl Filtri in Base al Edit**/

      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });

      }

      this.refreshPage([], '', this.SubjectCall, 'grid');
    }

    if (event.name == 'return') {
      this.filterID = [];
      sessionStorage.removeItem(this.apiset)
      this.refreshPage([], '', this.SubjectCall, 'grid');
    }

    if (event.name == "newCausale") {

      this.renderCausaleContent();
    }

    if (event.name == 'formularioCopy') {
      sessionStorage.removeItem(this.apiset)
      this.formularioCopy()
    }
    if (event.name == 'copiaComeNuovo') {
      console.log(event)
      if (event.row && event.row.data) {
        const newData = Object.assign(event.row.data, { quantitaKg: null, quantitaOrigineKg: null, annotazioni: null, protocollo: null, dataRegistrazione: new Date() })
        if (newData) this.getTempMovFromExisting(event.row.data.idPosizioneCausale, newData);

      }
      return
    }

    if (event.name == 'onInitilized') {
      if (!event.campo) {
        return
      }
      let filter = ''
      switch (event.campo.dataField) {

        case 'produttore_Descrizione_Full':
          filter = '?$filter=( isproduttore eq true )';
          this.rendereGridSoggetti(filter, event);

          break;
        case 'trasportatore_Descrizione_Full':
          filter = '?$filter=( istrasportatore eq true )';
          this.rendereGridSoggetti(filter, event);

          break;
        case 'destinatario_Descrizione_Full':
          filter = '?$filter=( issmaltitore eq true )';
          this.rendereGridSoggetti(filter, event);

          break;
        case 'intermediario_Descrizione_Full':
          filter = '?$filter=( isintermediario eq true )';
          this.rendereGridSoggetti(filter, event);

          break;
        default:

          break;
      }

    }



    //gestione eventi da bottone
    if (event.name == 'mostraScaricoR') {
      const data = event.row.data;
      data.idLotto_Sede = data['idProduttore']
      data.isGrid = true;

      let listaMagazziniDestinatario = [];
      event.cancella = true;

      this.anagraficaService.getElenco('MagazzinoRifiuti', '', '?idSede=' + data['idProduttore']).then(res => {
        if (res['items']) {
          res['items'].forEach(reee => {
            listaMagazziniDestinatario.push(reee['id']);
          })
          data.listaMagazziniDestinatario = listaMagazziniDestinatario;

          this.formCarichiDaAbbinareLista(data);
        }

      })


    }


    this.formButtonsEventMovDOc(event)

  }

  async generaRettifica(formData) {
    if (formData.protocollo) {

      return await this.apiService.PutApi("MovimentoRifiuti/ControllaVariazioniRentri", formData).then(async (convalidaResponse: any) => {
        if (convalidaResponse.variazioni.length > 0 && convalidaResponse.rettifiche.length > 0) {
          const variazioni = convalidaResponse.variazioni.map((val) => {
            return `<li>${val}</li>`
          })
          const regex = /Registro:\s*(.*?)\s+Protocollo:\s*(.*?)\s+Causale:\s*(.*)/;
          const rettifiche = convalidaResponse.rettifiche.map(riga => {
            const match = riga.match(regex);
            if (!match) return null;
            return `<tr>
                <td style="border: 1px solid #6f6f6f59;">${match[1].trim()}</td>
                <td style="border: 1px solid #6f6f6f59;">${match[2].trim()}</td>
                <td style="border: 1px solid #6f6f6f59;">${match[3].trim()}</td>
              </tr>`;
          }).filter(Boolean).join("");

          return await confirm(`Questo movimento è già protocollato sul registro RENTRI.<br/>Sono state modificate le seguenti voci:<br/>
            <ul>${variazioni}</ul>
            La modifica genererà una <strong>rettifica di variazione</strong> legata al movimento.<br/> Si desidera procedere?`, 'Attenzione').then(async (res) => {
            if (!res) return true
            return await confirm(`Saranno predisposte rettifiche alle seguenti registrazioni:<br/>
                <br/>
              <table border="1" cellspacing="0" cellpadding="5" style="width:100%; border: 1px solid #6f6f6f59;margin-top:3px">
              <thead>
                <tr>
                  <th style="border: 1px solid #6f6f6f59;">Registro</th>
                  <th style="border: 1px solid #6f6f6f59;">Protocollo</th>
                  <th style="border: 1px solid #6f6f6f59;">Causale</th>
                </tr>
              </thead>
              <tbody>
                ${rettifiche}
              </tbody>
            </table>
                      
              <br/>
            Le modifiche saranno effettuate alla prossima esportazione definitiva.<br/> Si desidera procedere?`, 'Attenzione').then((res) => {
              if (!res) return true
              if (this.formMovimento && this.template == 'form') this.formMovimento.onFormSubmit()
            })
          })

        } else {
          // event.resultSubject.next(true);
          // event.resultSubject.complete();
          // event.cancella = false;
          if (this.formMovimento && this.template == 'form') this.formMovimento.onFormSubmit()
          return
        }
      });
    }
    // event.resultSubject.next(true);
    // event.resultSubject.complete();
    // event.cancella = false;
    if (this.formMovimento && this.template == 'form') this.formMovimento.onFormSubmit()
    return false
  }

  formDataGridEventMovimento(event) {
    if (event.name == 'onRowExpandedDataGrid') {
      if (event.campo.dataField == 'produttore_Descrizione_Soggetto' || event.campo.dataField == 'destinario_Descrizione_Soggetto' || event.campo.dataField == 'trasportatore_Descrizione_Soggetto' || event.campo.dataField == 'intermediario_Descrizione_Soggetto') {
        if (typeof event.expandedData != 'undefined') {
          if (event.expandedData.length == 1) {

            let data = event.expandedData[0]
            this.formMovimento.updateFiedlFromGridSelection(data, event.campo);
            this.userComponentService.destroyCurrentOpenPopUpByGuid(event.guid)

          }
        }
      }

    }
    if (event.name == 'toolbarButtonClick') {
      const GrigliaComponent = event.dataGridComponent
      if (event.buttonEvent == 'newButtonClick' && event.campo.dataField == 'produttore_Descrizione_Full') {

        let api = 'soggetto';
        let service = 'soggetto';
        let template = "grid";

        let querystring =
        {
          NostreAziende: 'N',
          TipoAttivita: 'P'
        }
        let dataFilter = {
          nsAzienda: false,
          NostreAziende: 'N',
          TipoAttivita: 'P'
        }

        let data = [{
          api: api,
          service: service,
          titolo: '',
          breadcrumb: '',
          currentTabId: 'AnaSoggettoComponent',
          currentTabName: 'AnaSoggettoComponent',

          data: JSON.stringify(dataFilter),
          filter: JSON.stringify(dataFilter),
          helpDoc: null,
          componentName: 'AnaSoggettoComponent',
          templateView: template,
          descEvent: ''
        }]

        let guid = this.openComponentInPopUP('AnaSoggettoComponent', data, null, null, '', false, false, 'bottom');

        this.userComponentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.guid == guid) {

            console.log('currentOutputReturn-->', currentOutput);
            if (currentOutput.name == "closeTab") {

              GrigliaComponent.refresh()

            }

          }

        })

      }
    }
  }



  editorSoggettiByMovimento(event, isEdit) {

    const detailRif = event.detailRif[0];
    const componentName = detailRif.componentName
    const campo = event.campo;

    let dataFilter

    let id = ''
    if (isEdit) {
      id = event.data.id
    } else {
      if (campo) {

        let isProduttore = false;
        let isSmaltitore = false;
        let isTrasportatore = false;
        let isIntermediario = false;

        if (campo.dataField == 'produttore_Descrizione_Full') {
          isProduttore = true;
        }
        if (campo.dataField == 'destinatario_Descrizione_Full') {
          isSmaltitore = true;
        }
        if (campo.dataField == 'trasportatore_Descrizione_Full') {
          isTrasportatore = true;
        }
        if (campo.dataField == 'intermediario_Descrizione_Full') {
          isIntermediario = true;
        }
        dataFilter = {
          idSoggetto: event.data.id,
          isProduttore: isProduttore,
          isSmaltitore: isSmaltitore,
          isTrasportatore: isTrasportatore,
          isIntermediario: isIntermediario
        }

        dataFilter = JSON.stringify(dataFilter)

      }
    }







    const dataToSend = [{
      apiset: detailRif.api,
      id: id,
      service: detailRif.service ? detailRif.service : null,
      InviaA: null,
      staticQueryFilter: '',
      toolbarComponentFilter: null,
      filter: dataFilter,
      templateView: 'form',
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName

    }]
    const width = '1150'
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSend, width);
    this.loader.hide()
    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.name == "return" && currentOutput.guid == guid) {
        currentOutput.event.cancel = true;
        currentOutput.event.preventDefault();
        currentOutput.event.stopPropagation();
        event.masterComponent.refresh();
        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
        return
      }

      //console.log('currentOutput', currentOutput);

      if (currentOutput.name == "beforeSubmittedEdit" && currentOutput.guid == guid) {
        currentOutput.event.cancel = true;
        event.masterComponent.refresh();
        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
        return
      }

      if (currentOutput.eventName == "submittedInsertOk" && currentOutput.guid == guid) {
        currentOutput.event.cancel = true;
        event.masterComponent.refresh();
        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();
        return
      }

    })
  }

  rendereGridSoggetti(filter, event) {

    if (typeof event.masterComponent.chiaviDettagli != 'undefined') {
      event.masterComponent.chiaviDettagli[0].queryString = filter;
      event.masterComponent.chiaviDettagli[0].colonne = colonneSede
    }

    if (typeof event.masterComponent.colonneGrigliaTabella != 'undefined') {
      event.masterComponent.colonneGrigliaTabella = colonneSoggetto;
    }

  }

  formCarichiDaAbbinareLista(formData) {

    if ((this.filterID['isEdit'] && this.template == 'form') || this.template == 'grid') {
      formData.idMovimento = formData.id;
    } else {
      formData.idMovimento = '0';
    }


    let title = 'Carichi scaricabili alla data: ' + this.dateParseIT(formData.dataRegistrazione)
    title = "Elenco Carichi Abbinati"


    let componentName = 'GestioneCarichiMovimentoComponent'
    const dataToSend = [{
      apiset: '',
      id: '',
      service: 'elencocarichiAbbinati',
      title: title,
      InviaA: null,
      helpDoc: 'Relazionidicaricoescarico.html',
      data: formData,
      filter: JSON.stringify(formData),
      templateView: 'form',
      heightForm: 350,
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName


    }]

    const width = '1320';
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSend, width, null, null, false, true, title, 'center', 'Relazionidicaricoescarico.html');

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.event == 'saveScarico' && currentOutput.guid == guid) {
        let res = currentOutput;
        let data = formData
        if (res.listaCarichiDaAbbinare) {
          if (this.filterID['causale_Id_Operazione'] == 'B1' && data.quantitaKg == 0) {
            this.formMovimento.formRefreshInputData('quantitaKg', res.quantitaKg);
          }


          this.formMovimento.formRefreshInputData('listaCarichiDaAbbinare', res.listaCarichiDaAbbinare);
          this.formMovimento.formRefreshInputData('totaleDifferenzaPesoDaScaricare', res.totaleDifferenzaPesoDaScaricare);
          this.formMovimento.formRefreshInputData('idLotto', res.idLotto);
          this.formMovimento.formRefreshInputData('idCantiereFuoriUl', res.IdCantiereFuoriUL);
          this.formMovimento.formRefreshInputData('listaHP', res.listaHP);

          if (formData && typeof formData["eer"] == 'string' && !(formData["eer"] as string).endsWith("99")) {

            formData["descrizioneAssegnata"] = undefined;
            this.formMovimento.formRefreshInputData('descrizioneAssegnata', undefined);

          }

          /*
           
           Se la causale prevede la gestione dei carichi da lavorazione 
           piuttosto  che salvare il movimento viene proposto il poppup con la gestione carichi da lavorazione
 
          */


          if (data.causale_Id_Operazione == 'B1' && data.isCaricoAutomaticoRifiutiDaLavorazione && !this.filterID['isEdit']) {

            this.formPanelSchedaLavorazione(data);

          } else {
            // this.formMovimento.onFormSubmit();
            this.generaRettifica(data)
          }


          this.userComponentService.destroyCurrentOpenPopUp(componentName);
          this.userComponentService.destroyOutputComponent();

        }

        return;
      }
      if (currentOutput.name == 'return' && currentOutput.guid == guid) {


        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();



        return;
      }
    })
  }
  formCarichiDaAbbinare(event, formData) {

    if ((this.filterID['isEdit'] && this.template == 'form') || this.template == 'grid') {
      formData.idMovimento = formData.id;
    } else {
      formData.idMovimento = '0';
    }


    let title = 'Carichi scaricabili alla data: ' + this.dateParseIT(formData.dataRegistrazione)



    let componentName = 'GestioneCarichiMovimentoComponent'
    const dataToSend = [{
      apiset: '',
      id: '',
      service: 'scaricoRifiuto',
      title: title,
      InviaA: null,
      data: formData,
      filter: JSON.stringify(formData),
      templateView: 'form',
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName


    }]

    const width = '1320';
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSend, width);

    this.userComponentService.outputComponent.subscribe(async (currentOutput) => {
      if (currentOutput.event == 'saveScarico' && currentOutput.guid == guid) {
        let res = currentOutput;
        let data = formData
        if (res.listaCarichiDaAbbinare) {
          if (this.filterID['causale_Id_Operazione'] == 'B1' && data.quantitaKg !== 0) {
            this.formMovimento.formRefreshInputData('quantitaKg', res.quantitaKg);
          }


          this.formMovimento.formRefreshInputData('listaCarichiDaAbbinare', res.listaCarichiDaAbbinare);
          this.formMovimento.formRefreshInputData('totaleDifferenzaPesoDaScaricare', res.totaleDifferenzaPesoDaScaricare);
          this.formMovimento.formRefreshInputData('idLotto', res.idLotto);
          this.formMovimento.formRefreshInputData('idCantiereFuoriUl', res.IdCantiereFuoriUL);
          // this.formMovimento.formRefreshInputData('listaHP', res.listaHP);

          if (formData && typeof formData["eer"] == 'string' && !(formData["eer"] as string).endsWith("99")) {

            formData["descrizioneAssegnata"] = undefined;
            this.formMovimento.formRefreshInputData('descrizioneAssegnata', undefined);


          }

          /*
           
           Se la causale prevede la gestione dei carichi da lavorazione 
           piuttosto  che salvare il movimento viene proposto il poppup con la gestione carichi da lavorazione
 
          */


          if (data.causale_Id_Operazione == 'B1' && data.isCaricoAutomaticoRifiutiDaLavorazione && !this.filterID['isEdit']) {
            this.formPanelSchedaLavorazione(data);
          } else {
            await this.generaRettifica(formData)
          }


          this.userComponentService.destroyCurrentOpenPopUp(componentName);
          this.userComponentService.destroyOutputComponent();

        }

        return;
      }
      if (currentOutput.name == 'return' && currentOutput.guid == guid) {


        this.userComponentService.destroyCurrentOpenPopUp(componentName);
        this.userComponentService.destroyOutputComponent();



        return;
      }
    })
  }
  formPanelSchedaLavorazione(formData) {

    let title = 'Scheda lavorazione rifiuto'
    let congiunzione = ''
    let staticQueryFilter = '';

    let componentName = 'GestioneLavorazioniRifiutiComponent'

    if (!formData.eer && !formData.idStatoFisico && formData.quantitaKg) {
      alert('manca qualcosa forse la quantità', 'Attenzione')
      return
    }

    let dataToSendFromMov = {
      EER: formData.eer,
      IdStatoFisico: formData.idStatoFisico,
      RiferimentoEER: formData.riferimentoEER,
      QtaScaricata: formData.quantitaKg,
      idPosizioneRifiuto: formData.idPosizioneRifiuto,
      idProduttore: formData.idLotto_Sede
    }

    let dataToSenGestioneLavorazioniComponent = [{
      apiset: '',
      id: '',
      service: 'SchedaRifiutoLavorazione',
      title: title,
      InviaA: null,
      onlyRead: true,
      filter: JSON.stringify(dataToSendFromMov),
      data: formData,
      staticQueryFilter: staticQueryFilter,
      templateView: 'grid',
      template: 'grid',
      currentTabName: componentName,
      currentTabId: componentName,
      componentName: componentName

    }]

    const width = '1050';
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, dataToSenGestioneLavorazioniComponent, width, true);

    this.userComponentService.outputComponent.subscribe(currentOutput => {
      if (currentOutput.name == "return" && currentOutput.guid == guid) {
        console.log('return', currentOutput)

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()

        this.generaRettifica(formData)

      }
      if (currentOutput.name == "saveData" && currentOutput.guid == guid) {
        console.log('saveData', currentOutput)

        this.formMovimento.formRefreshInputData('listaSchedeLavorazioni', currentOutput.data)

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()

        this.generaRettifica(formData)


      }
      console.log('currentOutput', currentOutput)

    })
  }
  formPanelRintracciabilitaRifiuti(event, formData, isAttivaRintracciabilita, caricoDaMiscelazione) {

    let title = isAttivaRintracciabilita ? 'Scheda rintraccibilià rifiuto' : ''
    let congiunzione = ''
    let staticQueryFilter = '';
    let idMovimento = this.filterID['isEdit'] ? formData.id : 0;

    let componentName = 'GestioneRintracciabilitaRifiutiComponent'

    if (!formData.eer && !formData.dataRegistrazione) {
      //alert('manca qualcosa forse la quantità', 'Attenzione')
      return
    }

    let dataToSendFromMov = {
      isAttivaRintracciabilita: formData.isAttivaRintracciabilita,
      caricoDaMiscelazione: formData.caricoDaMiscelazione,
      listaHP: formData.listaHP,
      quantita: formData.quantitaKg,
      idMovimento: idMovimento,
      dataRegistrazione: formData.dataRegistrazione,
      title: title,
      formData: formData

    }



    const width = null;
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, null, width, null, dataToSendFromMov);

    this.userComponentService.outputComponent.subscribe(async (currentOutput) => {
      if (currentOutput.name == "return" && currentOutput.guid == guid) {

        let listaTr = [];

        if (!this.filterID['isEdit']) {
          listaTr = null;
        }


        return await this.generaRettifica(formData).then(res => {
          if (!res) {
            this.userComponentService.destroyCurrentOpenPopUp(componentName)
            this.userComponentService.destroyOutputComponent()
            this.formMovimento.formRefreshInputData('listaTracciabilita', listaTr)
            // this.formMovimento.onFormSubmit();
            return
          }
        })

      }
      if (currentOutput.name == "returnMov" && currentOutput.guid == guid) {
        //console.log('return', currentOutput)

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()


      }
      if (currentOutput.name == "saveData" && currentOutput.guid == guid) {
        console.log('saveData', currentOutput)

        this.formMovimento.formRefreshInputData('listaTracciabilita', currentOutput.data)

        this.generaRettifica(formData)

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()
      }
      //console.log('currentOutput', currentOutput)

    })
  }
  formPanelMiscelazione(event, formData, caricoDaMiscelazione) {

    let title = caricoDaMiscelazione ? 'Scheda di miscelazione rifiuto' : ''

    let idMovimento = this.filterID['isEdit'] ? formData.id : 0;

    let componentName = 'GestioneMiscelazioniRifiutiComponent'

    if (!formData.eer && !formData.idStatoFisico) {
      //alert('manca qualcosa forse la quantità', 'Attenzione')
      return
    }

    let dataToSend = {
      iscaricoDaMiscelazione: formData.caricoDaMiscelazione,
      listaHP: formData.listaHP,
      quantita: formData.quantitaKg,
      idMovimento: idMovimento,
      dataRegistrazione: formData.dataRegistrazione,
      title: title,
      eer: formData.eer,
      idStatoFisico: formData.idStatoFisico,
      riferimentoEER: formData.riferimentoEER,


    }
    let dataToSendFromMov = {
      itemData: dataToSend,
      formData: formData,
      titleDynamic: title
    }


    const width = null;
    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, componentName, null, width, null, dataToSendFromMov);

    this.userComponentService.outputComponent.subscribe(async (currentOutput) => {

      if (currentOutput.name == "return" && currentOutput.guid == guid) {

        let listaMisc = [];

        if (!this.filterID['isEdit']) {
          listaMisc = null;
        }

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()
        this.formMovimento.formRefreshInputData('listaMiscelazione', listaMisc)
        this.generaRettifica(formData)

      }
      if (currentOutput.name == "returnMov" && currentOutput.guid == guid) {

        this.userComponentService.destroyCurrentOpenPopUp(componentName)
        this.userComponentService.destroyOutputComponent()


      }

      if (currentOutput.name == "saveData" && currentOutput.guid == guid) {
        console.log('saveData', currentOutput)

        this.formMovimento.formRefreshInputData('listaMiscelazione', currentOutput.data)

        return await this.generaRettifica(formData).then(res => {
          if (!res) {
            // this.formMovimento.onFormSubmit()
            this.userComponentService.destroyCurrentOpenPopUp(componentName)
            this.userComponentService.destroyOutputComponent()
          }
        })


      }



    })
  }

  getQuantitaScaricabile(dataToSend) {
    const idMovimento = this.filterID['isEdit'] ? dataToSend.id : '0'
    let filter = '';

    filter += "?IdMovimento=" + idMovimento;

    if (dataToSend['dataRegistrazione']) {
      filter += "&DataRegistrazione=" + this.dateParse(dataToSend['dataRegistrazione']);

    }

    if (dataToSend['oraRegistrazione']) {
      filter += "&Ora=" + dataToSend['oraRegistrazione'];
    }

    if (dataToSend['eer']) {
      filter += "&EER=" + dataToSend['eer'];
    }

    if (dataToSend['idStatoFisico']) {
      filter += "&idStatoFisico=" + dataToSend['idStatoFisico'];
    }
    if (dataToSend['idProduttore']) {
      filter += "&IdProduttoreMovScarico=" + dataToSend['idProduttore'];
    }

    if (dataToSend['riferimentoEER']) {
      filter += "&RiferimentoEER=" + dataToSend['riferimentoEER'];
    }

    if (dataToSend['idCantiereFuoriUL']) {
      filter += "&IdCantiereFuoriUL=" + dataToSend['idCantiereFuoriUL'];
    }

    if (dataToSend['listaHP']) {
      dataToSend['listaHP'].forEach(hp => {
        filter += "&ListaHP=" + hp;
      })

    }

    filter += "&ListaIdTipoCarico=" + 'DT';

    if (dataToSend['idMagazzinoDestinatario']) {
      filter += "&ListaIdMagazzino=" + dataToSend['idMagazzinoDestinatario'];
    }




    const api = 'MovimentoRifiuti/GetQtaScaricabile'
    this.anagraficaService.getValue(api, '', filter).then(res => {
      let text = ''

      if (res) {
        text = "Qta scaric.: " + res + "Kg";

      }
      this.formMovimento.formEdit.instance.itemOption('dati-generali-movimento.quantitaKg', 'helpText', text);
    })
  }




  // openComponent(component, data, title?, popupWidth = 800, popupHeight = 500, toolBarVisible = true) {

  //   const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
  //   const factoryClass = <Type<any>>factories.find((x: any) => x.name === component);

  //   this._overlaySidePanelService.setTitle(title);

  //   this._overlaySidePanelService.setContent(factoryClass);
  //   this._overlaySidePanelService.sendDataToComponent(data);
  //   this._overlaySidePanelService.sendClassToComponent('scheda-tecnica-form')
  //   this._overlaySideFormService.setToolBarVisible(toolBarVisible)
  //   this._overlaySideFormService.setPopupWidth(popupWidth);
  //   this._overlaySideFormService.setPopupHeight(popupHeight);

  //   setTimeout(() => {

  //     if (typeof this._overlaySideFormService._hrefComponent.instance.outputEmit == 'undefined') {
  //       return;
  //     }
  //     (this._overlaySideFormService._hrefComponent.instance.outputEmit as EventEmitter<any>).subscribe(

  //       (res) => {

  //         if (res.event == 'saveScarico') {

  //           if (res.listaCarichiDaAbbinare) {
  //             if (this.filterID['causale_Id_Operazione'] == 'B1' && data.quantitaKg == 0) {
  //               this.formMovimento.formRefreshInputData('quantitaKg', res.quantitaKg);
  //             }


  //             this.formMovimento.formRefreshInputData('listaCarichiDaAbbinare', res.listaCarichiDaAbbinare);
  //             this.formMovimento.formRefreshInputData('totaleDifferenzaPesoDaScaricare', res.totaleDifferenzaPesoDaScaricare);
  //             this.formMovimento.formRefreshInputData('idLotto', res.idLotto);
  //             this.formMovimento.formRefreshInputData('idCantiereFuoriUl', res.IdCantiereFuoriUL);
  //             this.formMovimento.formRefreshInputData('listaHP', res.listaHP);

  //             /*

  //              Se la causale prevede la gestione dei carichi da lavorazione 
  //              piuttosto  che salvare il movimento viene proposto il poppup con la gestione carichi da lavorazione

  //             */


  //             if (data.causale_Id_Operazione == 'B1' && data.isCaricoAutomaticoRifiutiDaLavorazione && !this.filterID['isEdit']) {

  //               this.formPanelSchedaLavorazione({},data);

  //             } else {
  //               this.formMovimento.onFormSubmit();
  //             }


  //             this._overlaySideFormService.close();

  //           }

  //           return;
  //         }
  //         if (res.event == 'saveSoggetto') {

  //           let formData = this.formMovimento.dataSet;

  //           let idProduttore = formData.idProduttore;
  //           let idTrasportatore = formData.idTrasportatore;
  //           let idIntermediario = formData.idIntermediario;

  //           let arrayIdListaSoggetti = res.listaAltriSoggetti
  //           if (data.retunDatafield == 'listaAltriSoggettiT') {

  //             let trasportatoriArray = arrayIdListaSoggetti.filter(ress => {
  //               if (ress.idSoggetto == idTrasportatore) {
  //                 return ress
  //               }
  //             })

  //             if (trasportatoriArray.length > 0) {
  //               let trasportatoreDescArray = trasportatoriArray.map(res => {
  //                 return res.descrizione
  //               })

  //               let trasportatore = trasportatoreDescArray.toString()
  //               notify({
  //                 message: 'Trasportatore/i : ' + trasportatore + ' già scelto come princiale',
  //                 height: 45,
  //                 width: 250,
  //                 position: 'center center'

  //               }, 'error', 3000);
  //               console.log('index Trasportatore', trasportatore
  //               )
  //               return;

  //             }


  //           }

  //           if (data.retunDatafield == 'listaAltriSoggettiI') {

  //             let intermediariArray = arrayIdListaSoggetti.filter(ress => {
  //               if (ress.idSoggetto == idIntermediario) {
  //                 return ress
  //               }
  //             })

  //             if (intermediariArray.length > 0) {
  //               let trasportatoreDescArray = intermediariArray.map(res => {
  //                 return res.descrizione
  //               })

  //               let intermediari = trasportatoreDescArray.toString()
  //               notify({
  //                 message: 'Intermediario/i : ' + intermediari + ' già scelto come princiale',
  //                 height: 45,
  //                 width: 250,
  //                 position: 'center center'

  //               }, 'error', 3000);
  //               console.log('index Trasportatore', intermediari
  //               )
  //               return;

  //             }


  //           }


  //           this.formMovimento.formRefreshInputData(data.retunDatafield, res.listaAltriSoggetti);
  //           this._overlaySideFormService.close();
  //         }

  //         if (res.name == 'return') {

  //           this._overlaySideFormService.close();

  //           return;
  //         }

  //       }

  //     )
  //   }, 500);

  //   setTimeout(() => {
  //     (this._overlaySidePanelService._hrefComponent.instance.emittendSelectionRow as EventEmitter<any>).subscribe(



  //       (res) => {
  //         let currentFormData = this.formMovimento.dataSet
  //         let e = res;
  //         console.log('emittendSelectionRow-->', e)

  //         if (e.data) {
  //           let data = []
  //           data = res.data;

  //           for (let x in data) {
  //             if (currentFormData.hasOwnProperty(x)) {
  //               this.formMovimento.formRefreshInputData(x, data[x])
  //             }

  //           }
  //           if (typeof e.data.related != 'undefined') {
  //             let related = e.data.related
  //             for (let r in related) {
  //               if (currentFormData.hasOwnProperty(r)) {
  //                 this.formMovimento.formRefreshInputData(r, related[r])
  //               }

  //             }
  //           }
  //           this._overlaySideFormService.close();

  //           if (res.name == 'return') {

  //             this._overlaySideFormService.close();

  //             return;
  //           }

  //         }
  //       }




  //     )



  //   }, 500);
  //   this._overlaySidePanelService.show();


  // }


  scaricoAutomatico(ev) {

    if (this.SubjectCall == 'scaricoRifiuto') {

      const listaCarichiDaAbbinare = this.formMovimento.dataSet.listaCarichiDaAbbinare;

      this.formMovimento.formEdit.instance.updateData('totalePesoScaricato', null);

      this.totalPesoScaricato = 0

      if (listaCarichiDaAbbinare.length > 0) {
        let residuoTotale = 0
        const peso = this.filterID['peso'];
        listaCarichiDaAbbinare.forEach((res, row) => {
          residuoTotale += parseFloat(res.residuo)

          ev.masterComponent.cellValue(row, 'pesoScaricato', null);
          //this.formMovimento.formEdit.
        })
        let newResiduo = peso;
        let scaricato = 0;

        let lista = listaCarichiDaAbbinare.map((r, row) => {


          if (scaricato == peso) {
            return r
          }

          /* if (peso >= newResiduo) { */

          let scaricoDiff = newResiduo - r.residuo;

          if (scaricato <= peso) {
            let scaricoRifiuto = newResiduo - scaricoDiff

            if (scaricoDiff < 0) {
              let index = listaCarichiDaAbbinare.findIndex(resP => { return resP.residuo === newResiduo })

              if (index > 0) {
                scaricoRifiuto = newResiduo;
                ev.masterComponent.cellValue(index, 'pesoScaricato', scaricoRifiuto);
                r.pesoScaricato = scaricoRifiuto
                newResiduo = newResiduo - scaricoRifiuto;
                scaricato += scaricoRifiuto
                return r
              }

              scaricoRifiuto = newResiduo;
            }

            ev.masterComponent.cellValue(row, 'pesoScaricato', scaricoRifiuto);
            r.pesoScaricato = scaricoRifiuto
            newResiduo = newResiduo - scaricoRifiuto;
            scaricato += scaricoRifiuto
          }
          /* } */
          //console.log('scaricoAutomatico', r);
          return r

        })
        setTimeout(() => {
          if (scaricato == peso) {

            this.formMovimento.formEdit.instance.updateData('listaCarichiDaAbbinare', lista);
            this.totalPesoScaricato = scaricato;
            this.formMovimento.formEdit.instance.updateData('totalePesoScaricato', this.totalPesoScaricato)
          } else {
            this.formMovimento.formEdit.instance.updateData('listaCarichiDaAbbinare', null);

            listaCarichiDaAbbinare.map((r, row) => {

              r.pesoScaricato = null;

              ev.masterComponent.cellValue(row, 'pesoScaricato', null);
            })

            alert('Il totale dello scarico non è uguale al peso netto indicato nel movimento,modificare il peso netto', 'Attenzione!')

          }
        }, 300);



        //console.log('scaricoAutomatico', listaCarichiDaAbbinare);
      }

    }
  }

  svuotaColonnaScarico(ev) {
    if (this.SubjectCall == 'scaricoRifiuto') {

      const listaCarichiDaAbbinare = this.formMovimento.dataSet.listaCarichiDaAbbinare;


      this.totalPesoScaricato = 0

      if (listaCarichiDaAbbinare.length > 0) {


        listaCarichiDaAbbinare.map((r, row) => {

          r.pesoScaricato = null;

          ev.masterComponent.cellValue(row, 'pesoScaricato', null);
        })
        this.formMovimento.formEdit.instance.updateData('totalePesoScaricato', null);
      }

    }
  }

  filtriScarico(ev) {

    if (this.SubjectCall == 'scaricoRifiuto') {

      if (Object.keys(this.filterID['dataFiltriScarichiJson']).length > 0) {
        this.dataFiltriScarichiJson = this.filterID['dataFiltriScarichiJson']
      } else {
        this.dataFiltriScarichiJson = {

          idProduttoreScarico: this.filterID['idProduttore']
        }
      }


      this.buttonCustomFormFiltriScarico = [
        {

          location: "after",
          widget: "dxButton",
          locateInMenu: "never",
          stylingMode: 'text',
          text: 'Salva',
          icon: "glyphicon icon-salva-form",
          event: 'filterSalva'


        },
        {

          location: "after",
          widget: "dxButton",
          locateInMenu: "never",
          stylingMode: 'text',
          text: 'Annulla/Chiudi',
          icon: "glyphicon icon-annulla-form",
          event: 'filterAnnulla'


        },

      ]

      this.showFilterScarichiForm = true;

      this.dynamicGrid = ev.dynamicContent
    }
  }

  onAllEventFiltro(ev) {
    console.log('ciao');
    // console.warn(ev);


    if (ev.name == "ValueChangedListaLookup") {

      if (ev.campo.dataField == 'idProduttore') {

        if (!ev.value) {

          ev.component.itemOption('produttore.idAutorizzazioneProduttore', 'disabled', true);
          ev.component.getEditor('idAutorizzazioneProduttore').option('disabled', true);

          ev.component.itemOption('produttore.idMagazzinoProduttore', 'disabled', true);
          ev.component.getEditor('idMagazzinoProduttore').option('disabled', true);

          this.nicaFiltro.filtroForm.formEdit.formData['idProduttore'] = undefined;

        }

      }

      if (ev.campo.dataField == 'idTrasportatore') {

        if (!ev.value) {

          ev.component.itemOption('trasportatore.idAutomezzo', 'disabled', true);
          ev.component.getEditor('idAutomezzo').option('disabled', true);

          ev.component.itemOption('trasportatore.idRimorchio', 'disabled', true);
          ev.component.getEditor('idRimorchio').option('disabled', true);


          ev.component.itemOption('trasportatore.idAlbo', 'disabled', true);
          ev.component.getEditor('idAlbo').option('disabled', true);

          ev.component.itemOption('trasportatore.idAutista', 'disabled', true);
          ev.component.getEditor('idAutista').option('disabled', true);


          ev.component.itemOption('trasportatore.idCategoriaAlbo', 'disabled', true);
          ev.component.getEditor('idCategoriaAlbo').option('disabled', true);


          this.nicaFiltro.filtroForm.formEdit.formData['idTrasportatore'] = undefined;

        }

      }

      if (ev.campo.dataField == 'idDestinatario') {

        if (!ev.value) {

          ev.component.itemOption('destinatario.idAutorizzazioneDestinatario', 'disabled', true);
          ev.component.getEditor('idAutorizzazioneDestinatario').option('disabled', true);

          ev.component.itemOption('destinatario.idMagazzinoDestinatario', 'disabled', true);
          ev.component.getEditor('idMagazzinoDestinatario').option('disabled', true);

          this.nicaFiltro.filtroForm.formEdit.formData['idDestinatario'] = undefined;

        }

      }

      if (ev.campo.dataField == 'idIntermediario') {

        if (!ev.value) {

          ev.component.itemOption('intermediario.idAutorizzazioneIntermediario', 'disabled', true);
          ev.component.getEditor('idAutorizzazioneIntermediario').option('disabled', true);

          this.nicaFiltro.filtroForm.formEdit.formData['idIntermediario'] = undefined;
        }

      }


    }


    try {
      if (this.nicaFiltro)
        if (this.nicaFiltro.filtroForm) {

          if (!this.nicaFiltro.filtroForm.formEdit.formData['idAlbo']) {

            if (ev.component) {

              ev.component.itemOption('trasportatore.idCategoriaAlbo', 'disabled', true);
              ev.component.getEditor('idCategoriaAlbo').option('disabled', true);

            }


          }
        }
    } catch (ex) {


    }
  }

  /****Filtri Movimento Scarico****/
  emittendButtonPushFilter(ev) {

    if (ev == 'salva') {
      console.log('ciao');
      const formData = this.movimentoFiltriScarichi.formEdit.formData;
      let filter = ''

      if (this.filterID['isEdit']) {

        filter += "?IdMovimento=" + this.filterID['id'];


      } else {
        filter += "?IdMovimento=0";
      }

      if (this.filterID['idCausale']) {
        filter += "&IdCausaleMovScarico=" + this.filterID['idCausale'];
      } else {
        alert("C'è stato un problema", 'Errore!')
        return;
      }

      if (this.filterID['idOperazioneRD']) {
        filter += "&IdOperazioneRDMovScarico=" + this.filterID['idOperazioneRD'];
      } else {
        alert("C'è stato un problema", 'Errore!')
        return;
      }


      if (this.filterID['dataRegistrazione']) {
        filter += "&DataRegistrazione=" + this.dateParse(this.filterID['dataRegistrazione']);

      } else {
        alert("C'è stato un problema data registrazione documento mancante", 'Errore!')
        return;
      }

      if (this.filterID['oraRegistrazione']) {
        filter += "&Ora=" + this.filterID['oraRegistrazione'];
      }

      if (this.filterID['cer']) {
        filter += "&CER=" + this.filterID['cer'];
      }

      if (this.filterID['idStatoFisico']) {
        filter += "&idStatoFisico=" + this.filterID['idStatoFisico'];
      }
      if (this.filterID['idProduttore']) {
        filter += "&IdProduttoreMovScarico=" + this.filterID['idProduttore'];
      }



      if (this.filterID['riferimentoDocumento']) {
        filter += "&Riferimento=" + this.filterID['riferimentoDocumento'];
      }

      if (formData['listaHP']) {

        const listaHP = formData['listaHP'];
        let string = "ListaHP=";
        let separator = ''

        listaHP.forEach((hp, index) => {

          separator = '&';

          filter += separator + string + hp
        })

      }

      if (formData['ListaMagazzini']) {
        const listaMagazzini = formData['ListaMagazzini'];
        let string = "ListaIdMagazzino=";
        let separator = ''
        if (Array.isArray(listaMagazzini)) {
          listaMagazzini.forEach((magazzinoOBJ, index) => {

            separator = '&';

            filter += separator + string + magazzinoOBJ.id
          })
        }
        //filter += "&ListaIdMagazzino=" + this.filterID['idMagazzinoProduttore'];
      }

      if (formData['ListaIdTipoCarico']) {

        const ListaIdTipoCarico = formData['ListaIdTipoCarico'];
        let string = "ListaIdTipoCarico=";
        let separator = ''

        ListaIdTipoCarico.forEach((idTipoCarico, index) => {

          separator = '&';

          filter += separator + string + idTipoCarico
        })

      }

      if (formData['IsDepositoTemporaneo']) {

        filter += '&IsDepositoTemporaneo=' + formData['IsDepositoTemporaneo']
      }
      if (formData['IdProduttoreMovCarico']) {

        filter += '&IdProduttoreMovCarico=' + formData['IdProduttoreMovCarico']
      }


      this.dynamicGrid.filterNomeTabella = filter
      this.dynamicGrid.refreshDataSource();

      this.showFilterScarichiForm = false;
      this.dataFiltriScarichiJson = formData;

      this.filterID['dataFiltriScarichiJson'] = this.dataFiltriScarichiJson
    }

    if (ev == 'filterAnnulla') {
      this.showFilterScarichiForm = false;
    }
  }




  closePopUp(e) {

    this.showFilterScarichiForm = false;
    this.elencoFormulariVisibile = false
  }

  emitGridScarico(event) {
    // console.log('emitGridScarico', event)
  }



  jsAddAtribute(className: string) {
    let elementByClassProd = document.getElementsByClassName(className);

    Array.from(elementByClassProd).forEach((el) => {
      if (el.tagName == 'INPUT') {
        el.setAttribute('readOnly', 'readOnly')
      }
      //console.log('tagName', el.tagName);
    });
  }

  // modifica da adele filtri :

  onShowing(e) {
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content
    setTimeout(() => {
      var tt = $(".soggetto-form").find(".dx-item .dx-box-item");
    }, 200);
  }
  appToolBarEvent(evt) {
    console.warn(evt);
  }




  setDisabledToolbar() {
    return this.id == '0' || !this.id ? true : false
  }

}
